<script setup lang="ts">
import { computed } from 'vue'
import { bfsImage } from '@/utils/img'

interface IProps {
  src: string
  class?: string
  style?: any
  width?: number
  height?: number
  center?: boolean
}
const props = defineProps<IProps>()
</script>
<template>
  <img v-if="props.src" :src="bfsImage(props.src, props.width, props.height)" alt="" :class="props.class" :style="props.style" />
</template>
